<template>
  <!-- 导入线下打款订单弹框 -->
  <el-dialog title="批量导入机型标记" :visible.sync="visible" :close-on-click-modal="false" width="540px">
    <div class="cance_tip">
      <div>说明：导出待标记机型后，完善表格数据后导入进行标记，单次最多可标记1000条</div>
    </div>
    <el-button type="success" icon="el-icon-download" size="small" @click="download"
      :loading="loading">下载数据模板</el-button>
    <el-button :loading="loading" type="danger" icon="el-icon-download" size="small"
      @click="downloadLocal">导出未标记机型(仅手机)</el-button>
    <!-- 上传 -->
    <el-form ref="importForm" :model="importForm" :rules="importRules" label-width="80px" style="margin-top: 20px;">
      <el-form-item label="表格上传" prop="fileName" class="fileName">
        <el-input v-model="importForm.fileName" @clear="fileClear" readonly size="medium" clearable>
          <i slot="suffix" class="el-input__icon el-icon-delete" @click="fileClear"></i>
        </el-input>
        <div style="float: right; position: relative">
          <el-button size="medium" type="warning" icon="el-icon-upload2" :loading="loading">上传表格</el-button>
          <input accept=".xls, .xlsx" ref="fileUpload" @change="fileChange" type="file" style="
                opacity: 0;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                cursor: pointer;
              " />
        </div>
        <div style="color: #ff687b">
          仅支持.xls及.xlsx格式,单次上传大小不超过5M
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click.native="visible = false" :loading="loading">取消</el-button>
      <el-button type="primary" @click.native="confirm" :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _api from "@/utils/request";
import { guideExcelAction } from "@/utils/common";
import { MessageBox } from "element-ui";

export default {
  name: 'ImportDia',
  data() {
    return {
      visible: false,
      loading: false,

      importForm: {
        fileName: '',
        file: null
      },
      importRules: {},
      searchP: {}
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    }
  },
  watch: {
    SeachParams(newVal) {
      console.log('newVal', newVal);
      this.searchP = newVal
      console.log('......', this.searchP);

    }
  },
  methods: {
    open() {
      this.fileClear()
      this.visible = true
    },
    // ************
    // 模板下载
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入标记机型数据模板.xlsx";
      link.setAttribute("download", "导入标记机型数据模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    downloadLocal() {
      console.log('this.searchP', this.searchP);
      this.searchP.machineTypeId = 26
      this.searchP.mark = '10'
      this.loading = true

      _api.modelExcel(this.searchP)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);

          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            //
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = '未标记机型.xlsx'
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
          this.loading = false

        }).finally(() => {
          this.loading = false

        });
    },
    // 选择文件
    fileChange(event) {
      if (event.target.files) {
        const file = event.target.files[0]
        this.importForm.file = file;
        this.importForm.fileName = file.name;
      }
    },
    confirm() {
      const file = this.importForm.file
      if (!file) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      fd.append("file", file)
      this.loading = true
      _api.modelImportMark(fd).then(res => {
        this.$message({
          type: "success",
          message: res.msg,
        });
        this.visible = false
        this.$emit('confirm')
        this.loading = false

      }).finally((res) => {
        this.fileClear()
        this.loading = false
        this.$message({
          type: 'error',
          message: res.msg,
        });
      })
    },
    // 确定导出
    // uploadFile() {
    //   if (!this.paramsExcel.file || this.paramsExcel.file.length == 0) {
    //     return this.$message.error("请上传表格");
    //   }
    //   const fd = new FormData();
    //   console.log(this.paramsExcel);
    //   fd.append("file", this.paramsExcel.file[0]); //文件
    //   // fd.append("supplierId", this.supplierId); //出库商家id
    //   // fd.append("warehouseId", this.warehouseId); //仓库id
    //   console.log(fd);
    //   this.repeatData = []
    //   // 发起请求
    //   _api
    //     .bindMachineFhBatch(fd)
    //     .then((res) => {
    //       console.log("_RequestUploads_", res);
    //       this.importList = res.data
    //       this.isImported=true
    //       console.log(this.importList, '4444444444444444444');
    //       if (res.code === 1) {
    //         this.importForm.fileName = "";
    //         this.$refs.fileUpload.value = "";
    //         let erraction = JSON.parse(JSON.stringify(res))
    //         let erractioncopy = JSON.parse(JSON.stringify(res))
    //         this.seachDataList.unshift(...res.data)
    //         this.$message({
    //           type: "success",
    //           message: '导入成功！',
    //         });
    //       } else {
    //         this.$message({
    //           type: "warning",
    //           message: res.msg,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.importForm.fileName = "";
    //       this.$refs.fileUpload.value = "";
    //     });
    // },
    fileClear() {
      console.log(123)
      if (this.$refs["fileUpload"]) this.$refs["fileUpload"].value = "";
      this.importForm = {
        fileName: '',
        file: null
      }
    },
    // importSuccess() {
    //   _api.importSave({ list: this.importList }).then(res => {
    //     if (res.code === 1) {
    //       this.importVisible = false
    //       this.importList = []
    //       this.isImported=false
    //         this.$message({
    //           type: "success",
    //           message: res.msg || '操作成功',
    //         });
    //     }
    //   })
    // },
    // exportinDialogClosed() {
    //   this.importVisible = false
    //   this.importList = []
    //   this.isImported=false
    // },
  }
}
</script>

<style lang="scss" scoped>
.cance_tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;
}

.fileName {
  /deep/.el-input {
    width: 260px;
  }

  /deep/.el-button {
    // border-radius: 10px;
    margin-right: 0px;
  }
}
</style>